import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

// Packages
import { Button, Col, Flex, Row, Typography  } from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Components
import ConsumableForm from './ConsumableForm';
import ConsumablesTable from './ConsumablesTable';

// Actions
import { get_all_consumables } from '../../../redux/actions/consumablesActions';

const Consumables = (props) => {
	const { messageApi } = props;

	const { t } = useTranslation();

	const dispatch = useDispatch();

	const [isModalOpen, setIsModalOpen] = useState(false);
	const [update, setUpdate] = useState(false);
	const [consumableToUpdate, setConsumableToUpdate] = useState({});
	const [pageSize, setPageSize] = useState(10);
	const [skip, setSkip] = useState(0);

	useEffect(() => {
		const savedSkip = parseInt(localStorage.getItem('consumablesSkip')) || 0;
		setSkip(savedSkip);

		const savedPageSize = parseInt(localStorage.getItem('consumablesPageSize')) || 10;
		setPageSize(savedPageSize);

		const filters = { skip: savedSkip, limit: savedPageSize };
		dispatch(get_all_consumables(filters));
	}, []);

	const handleAdd = () => {
		setIsModalOpen(true);
		setUpdate(false);
		setConsumableToUpdate({});
	}

	return (
		<div>
			<ConsumableForm
				messageApi={messageApi}
				isModalOpen={isModalOpen}
				setIsModalOpen={setIsModalOpen}
				update={update}
				consumableToUpdate={consumableToUpdate}
				setConsumableToUpdate={setConsumableToUpdate}
				pageSize={pageSize}
				skip={skip}
			/>

			<Row>
				<Col xs={24} sm={18} md={18} lg={18} xl={18}>
					<Typography.Title>{t('menuItems.game.consumables')}</Typography.Title>
				</Col>
				<Col xs={24} sm={6} md={6} lg={6} xl={6}>
					<Flex align='center' justify='flex-end' style={{ height: '100%' }}>
						<Button
							type='primary'
							size='large'
							onClick={handleAdd}
						>
							{t('buttons.create')}
						</Button>
					</Flex>
				</Col>
			</Row>

			<ConsumablesTable
				messageApi={messageApi}
				setIsModalOpen={setIsModalOpen}
				setUpdate={setUpdate}
				setConsumableToUpdate={setConsumableToUpdate}
				pageSize={pageSize}
				setPageSize={setPageSize}
				skip={skip}
				setSkip={setSkip}
			/>
		</div>
	)
}

Consumables.propTypes = {
	messageApi: PropTypes.object.isRequired
}

export default Consumables;
